import React from 'react';
export function HeroSection() {
  return <section id="home" className="bg-gradient-to-r from-blue-900 to-blue-700 text-white" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-211">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-212">
          <div data-id="element-213">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-214">
              Your Trusted Partner for Financial Growth
            </h1>
            <p className="text-lg md:text-xl mb-8" data-id="element-215">
              Max Cap Securities, a sub-broker of TradeJini, provides reliable
              investment solutions with expert guidance to help you achieve your
              financial goals.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-216">
              <a href="#contact" className="inline-block bg-white text-blue-800 px-6 py-3 rounded-md font-medium text-center hover:bg-gray-100" data-id="element-217">
                Open an Account
              </a>
              <a href="#services" className="inline-block bg-transparent border border-white text-white px-6 py-3 rounded-md font-medium text-center hover:bg-blue-800" data-id="element-218">
                Explore Services
              </a>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-219">
            <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Stock market data visualization" className="rounded-lg shadow-lg w-full" data-id="element-220" />
          </div>
        </div>
      </div>
      <div className="bg-blue-800 py-4" data-id="element-221">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
          <div className="flex flex-wrap justify-between items-center text-sm" data-id="element-223">
            <p data-id="element-224">SEBI Registration No: INZ000038535</p>
            <p data-id="element-225">Member: NSE, BSE, MCX</p>
            <p data-id="element-226">Authorized Sub-broker of TradeJini</p>
          </div>
        </div>
      </div>
    </section>;
}